var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from 'reactstrap';
import './oto-control.scss';
var OtoDropdown = function (props) {
    var options = props.options, icon = props.icon, label = props.label, onChange = props.onChange, value = props.value;
    var _a = __read(useState(false), 2), dropdownOpen = _a[0], setDropdownOpen = _a[1];
    var valueLabel = (options.find(function (opt) { return opt.name === value; }) || options[0]).label;
    var toggle = function () { return setDropdownOpen(!dropdownOpen); };
    return (React.createElement(Dropdown, { isOpen: dropdownOpen, toggle: toggle, className: "oto-control ".concat(dropdownOpen ? 'oto-control--open' : '') },
        React.createElement(DropdownToggle, { className: "oto-control__toggle", tag: "div", "aria-expanded": dropdownOpen },
            React.createElement("div", { className: "oto-control__label" },
                React.createElement("img", { src: "/storage/img/icons/".concat(icon), "aria-hidden": "true" }),
                label),
            React.createElement("div", { className: "oto-control__text" }, valueLabel)),
        React.createElement(DropdownMenu, { className: "oto-control__menu" }, options.map(function (opt) { return (React.createElement(DropdownItem, { key: opt.name, className: "oto-control__menu-item ".concat(value === opt.name ? 'oto-control__menu-item--active' : ''), onClick: function () {
                onChange(opt.name);
                toggle();
            } }, opt.label)); }))));
};
export default OtoDropdown;
OtoDropdown.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }).isRequired).isRequired,
    icon: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};
